import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { RouteParameters } from 'constants/'
import { Route } from '../../../../constants/route'
import {
  ClickTrackingProvider,
  FormAnalyticsProvider,
  IsManualModeProvider,
  SessionDurationProvider,
  useCountry,
  useRescheduleContext,
} from 'hooks'
import { AppointmentFormData } from 'types'
import { hydratePathname, pick } from 'util/'
import { Card, Width } from '../../../Card'
import { Content } from './Content'

const New = () => {
  const [isReady, beReady] = useState(false)
  const navigate = useNavigate()
  const country = useCountry()
  const { [RouteParameters.APPOINTMENT_ID]: appointmentId } = useParams()
  const rescheduleContext = useRescheduleContext()

  useEffect(() => {
    const formData = pick(rescheduleContext, ['appointment', 'description', 'reason', 'techSetupFailReason'])

    if (!isReady) {
      beReady(true)

      return
    }

    if (formData) {
      return
    }

    const pathname = hydratePathname(Route.APPOINTMENT_RESCHEDULE, {
      [RouteParameters.COUNTRY]: country,
      [RouteParameters.APPOINTMENT_ID]: appointmentId,
    })

    navigate(pathname, { replace: true })
  }, [isReady])

  if (!isReady) return null

  return (
    <SessionDurationProvider>
      <ClickTrackingProvider>
        <IsManualModeProvider>
          <FormAnalyticsProvider<AppointmentFormData>>
            <Card width={Width.LARGE}>
              <Content />
            </Card>
          </FormAnalyticsProvider>
        </IsManualModeProvider>
      </ClickTrackingProvider>
    </SessionDurationProvider>
  )
}

export { New }
